import { createContext, useEffect, useState } from "react";
import { useTwilioToken } from "../../api/TwilioToken";
import { connect } from "twilio-video";
import { notification } from "antd";

export const RoomContext = createContext({
  display: undefined,
  audioEnabled: undefined,
  videoEnabled: undefined,
  toggleDisplay: () => undefined,
  room: undefined,
  connectToRoom: () => undefined,
  disconnectFromRoom: () => undefined,
  audioDevice: undefined,
  setAudioDevice: () => undefined,
  videoDevice: undefined,
  setVideoDevice: () => undefined,
  selectedParticipant: undefined,
  setSelectedParticipant: () => undefined,
  setVideoTrack: () => undefined,
  setAudioTrack: () => undefined,
});

export const participantLayout = {
  spotlight: "spotlight",
  tiled: "tiled",
  sidebar: "sidebar",
};

export const RoomContextProvider = ({ children }) => {
  const [display, setDisplay] = useState(participantLayout.sidebar);
  const [connecting, setConnecting] = useState();
  const [selectedParticipant, setSelectedParticipant] = useState();
  const [videoTrack, setVideoTrack] = useState();
  const [audioTrack, setAudioTrack] = useState();

  const [audioEnabled, setAudioEnabled] = useState(true);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [videoDevice, setVideoDevice] = useState();
  const [audioDevice, setAudioDevice] = useState();

  const [room, setRoom] = useState();

  const twilioToken = useTwilioToken();

  useEffect(() => {
    if (room) {
      room.on("participantConnected", function (p) {
        notification.open({
          message: `${p.identity} joined`,
          description: "Someone joined your session",
        });
      });
      room.on("participantDisconnected", function (p) {
        notification.open({
          message: `${p.identity} left`,
          description: "Someone joined your session",
        });
      });
    }
  }, [room]);

  // useEffect(() => {
  //   if (!room) return;
  //   const local = room?.localParticipant;
  //   console.log(local);
  // }, [videoDevice]);

  // useEffect(() => {
  //   if (!room) return;

  //   const localParticipant = room?.localParticipant;
  //   // console.log(local);
  //   createLocalAudioTrack({ deviceId: audioDevice }).then((track) => {
  //     // console.log(track);
  //     const tracks = Array.from(localParticipant.audioTracks.values());
  //     console.log(tracks);
  //     // localParticipant.unpublishTracks(tracks);
  //     // localParticipant.publishTrack(track);

  //     // log(localParticipant.identity   " removed track: "   tracks[0].kind);
  //     // detachTracks(tracks);

  //     // localParticipant.publishTrack(localVideoTrack);
  //     // log(localParticipant.identity   " added track: "   localVideoTrack.kind);
  //     // const previewContainer = document.getElementById('local-media');
  //     // attachTracks([localVideoTrack], previewContainer);
  //   });
  // }, [audioDevice]);

  const connectToRoom = async (
    identity,
    roomName,
    // TODO: Implement the rest of these params
    roomType = "recording",
    onFinally,
    tokenDuration
  ) => {
    setConnecting(true);
    twilioToken
      .mutateAsync({ identity: identity, name: roomName })
      .then((response) => {
        const { Token } = response;
        connect(Token, {
          name: roomName,
          bandwidthProfile: {
            video: {
              dominantSpeakerPriority: "high",
              mode: "collaboration",
              clientTrackSwitchOffControl: "auto",
              contentPreferencesMode: "auto",
            },
          },
          dominantSpeaker: true,
          ...[videoTrack, audioTrack],
          // video: {
          //   height: 720,
          //   frameRate: 24,
          //   width: 1280,
          //   facingMode: "user",
          // },
          // audio: true,
        })
          .then((r) => {
            setRoom(r);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .finally(() => {
        setConnecting(false);
      });
  };

  const roomContext = {
    display: display,
    audioEnabled: audioEnabled,
    setAudioEnabled: setAudioEnabled,
    videoEnabled: videoEnabled,
    setVideoEnabled: setVideoEnabled,
    toggleDisplay: (value) => {
      setDisplay(value);
    },
    connectToRoom: async (identity, roomName) => {
      await connectToRoom(identity, roomName);
    },
    connecting: connecting,
    room: room,
    audioDevice: audioDevice,
    setAudioDevice: setAudioDevice,
    videoDevice: videoDevice,
    setVideoDevice: setVideoDevice,
    disconnectFromRoom: () => {
      room.disconnect();
      setRoom();
    },
    selectedParticipant: selectedParticipant,
    setSelectedParticipant: setSelectedParticipant,

    videoTrack: videoTrack,
    audioTrack: audioTrack,
    setVideoTrack: setVideoTrack,
    setAudioTrack: setAudioTrack,
  };

  return (
    <RoomContext.Provider value={roomContext}>{children}</RoomContext.Provider>
  );
};
